import { render, staticRenderFns } from "./buy_new.vue?vue&type=template&id=06ca061c&scoped=true&"
import script from "./buy_new.vue?vue&type=script&lang=js&"
export * from "./buy_new.vue?vue&type=script&lang=js&"
import style0 from "./buy_new.vue?vue&type=style&index=0&id=06ca061c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca061c",
  null
  
)

export default component.exports